import { useReducer, useEffect, useMemo } from "react";
import { Form } from "antd";
import { MessageType } from "../../types/messageType";
import { createReasonPause, deleteRequestReasonPause, getReasonPause, putReasonPause } from "../../config";
import { MessageAnt } from "../../redux/slices/ui/uiAction";
import { columnsPauses } from "../../types/columnsTables/columnPauses";

const initialState = {
	isLoading: false,
	searchValue: "",
	tableData: [],
	activeModal: false,
	typeModal: 0,
	dataForm: {},
	selectedPause: "",
	loadingButton: false,
};

function reducer(state, action) {
	switch (action.type) {
		case "SET_LOADING":
			return { ...state, isLoading: action.payload };
		case "SET_SEARCH_VALUE":
			return { ...state, searchValue: action.payload };
		case "SET_TABLE_DATA":
			return { ...state, tableData: action.payload };
		case "SET_ACTIVE_MODAL":
			return { ...state, activeModal: action.payload };
		case "SET_TYPE_MODAL":
			return { ...state, typeModal: action.payload };
		case "SET_DATA_FORM":
			return { ...state, dataForm: action.payload };
		case "SET_SELECTED_PAUSE":
			return { ...state, selectedPause: action.payload };
		case "SET_LOADING_BUTTON":
			return { ...state, loadingButton: action.payload };
		default:
			throw new Error(`Unknown action type: ${action.type}`);
	}
}

export const usePagePausesData = () => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const [form] = Form.useForm();

	const editAction = async (form) => {
		if (form) {
			dispatch({ type: "SET_DATA_FORM", payload: { ...form } });
			dispatch({ type: "SET_SELECTED_PAUSE", payload: form.key });
		}
		dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
	};

	const deleteAction = async (key) => {
		const { status } = await deleteRequestReasonPause({ status: false, id: key });
		if (status > 0) {
			MessageAnt(MessageType.error, "Error al eliminar motivo");
		} else {
			setData();
		}
	};

	const setData = () => {
		dispatch({ type: "SET_LOADING", payload: true });
		getReasonPause()
			.then(({ status, payload }) => {
				if (status !== 0) return;
				const newPauseTable = payload.map((pay) => {
					return {
						...pay,
						key: pay._id,
					};
				});
				dispatch({ type: "SET_TABLE_DATA", payload: newPauseTable });
			})
			.catch((error) => console.error(error))
			.finally(() => dispatch({ type: "SET_LOADING", payload: false }));
	};

	const handleOpenModalCreate = () => {
		dispatch({ type: "SET_DATA_FORM", payload: { isActive: true, name: "" } });
		dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
		dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
	};

	const handleOnCancel = () => {
		dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
		dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
	};

	const onFinish = async (values) => {
		dispatch({ type: "SET_LOADING_BUTTON", payload: true });
		const structureForm = {
			...values,
		};
		if (state.typeModal === 0) {
			const { status } = await createReasonPause(structureForm);
			if (status > 0) {
				MessageAnt(MessageType.error, "Error al crear motivo");
			}
		} else {
			const { status } = await putReasonPause({ ...structureForm, id: state.selectedPause });
			if (status > 0) {
				MessageAnt(MessageType.error, "Error al editar motivo");
			}
		}
		dispatch({ type: "SET_LOADING_BUTTON", payload: false });
		setData();
		dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
	};

	const handleChange = (e) => {
		dispatch({ type: "SET_SEARCH_VALUE", payload: e.target.value });
	};

	const { columns, props } = columnsPauses(
		editAction,
		deleteAction,
		(active) => dispatch({ type: "SET_ACTIVE_MODAL", payload: active }),
		(type) => dispatch({ type: "SET_TYPE_MODAL", payload: type })
	);
	const { pagination, ...tableProps } = props;

	const tableFilterDataPauses = useMemo(() => {
		return state.tableData.filter((item) => {
			let isFilter = [];
			isFilter.push(item.name.toLocaleLowerCase().includes(state.searchValue.toLocaleLowerCase()));
			return isFilter.every((value) => value);
		});
	}, [state.tableData, state.searchValue]);

	useEffect(() => {
		form.setFieldsValue({
			isActive: state.dataForm.isActive,
			name: state.dataForm.name,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.dataForm]);

	useEffect(() => {
		setData();
	}, []);

	return {
		searchValue: state.searchValue,
		activeModal: state.activeModal,
		typeModal: state.typeModal,
		loadingButton: state.loadingButton,
		form,
		isLoading: state.isLoading,
		handleOpenModalCreate,
		handleOnCancel,
		onFinish,
		tableFilterDataPauses,
		handleChange,
		columns,
		tableProps,
		pagination,
	};
};
